import React from "react";
import styles from "./Header.Rrofile.module.scss";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";

function HeaderProfile() {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.headerBack} onClick={() => navigate(-1)}>
        <MdArrowBackIosNew />
      </div>

      <div className={styles.space}></div>
    </div>
  );
}

export default HeaderProfile;